<template>
  <b-modal
    id="hospitalization-send-alert-modal"
    :title="!hospitalization.needAlert ? 'Souhaitez-vous envoyer une alerte au propriétaire ?' : 'Souhaitez-vous ne plus alerter le propriétaire ?'"
    @ok="handleOk"
    ok-title="Envoyer"
    ok-variant="success rounded"
    cancel-title="Annuler"
    cancel-variant="primary rounded"
  >
  </b-modal>
</template>

<script>
import api from '../../services/api';

export default {
  name: "HospitalizationSendAlertModal",
  data:{
    title: null,
  },
  props: {
    hospitalization: Object
  },
  emits: ['didHandleAlert'],

  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault(); // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
         let data = new FormData()
             data.append('hospitalizationId', this.$props.hospitalization.id);
             api({
                 method: 'POST',
                 url: '/hospitalization/alertUser',
                 data: data
             })
                 .then(response => {
                     this.hideModal()
                     if(this.$props.hospitalization.needAlert !== true){
                         this.successToast(`Une notification a été envoyée au propriétaire.`)
                     }
                     this.$emit('didHandleAlert')
                 })
                 .catch((error) => {
                     if (error.response.status === 418) {
                         this.$bvToast.toast(error.response.data.message, {
                             autoHideDelay: 2000,
                             toaster: 'b-toaster-bottom-right'
                         })
                     }
                 });

    },

    hideModal() {
      this.$bvModal.hide('hospitalization-send-alert-modal')
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/hospitalization/HospitalizationSendAlertModal.vue